import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { X, Send, CheckCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const QuoteFormModal = ({ productName, onClose }) => {
  const { t, isRTL } = useLanguage();
  const [products, setProducts] = useState([]);
  const lang = isRTL ? 'ar' : 'en';
  const [form, setForm] = useState({
    name: '', company: '', phone: '', email: '', city: '', product: productName || '', description: '',
  });
  const [status, setStatus] = useState('');

  useEffect(() => {
    axios.get(`${API}/api/products`).then(r => setProducts(r.data)).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      await axios.post(`${API}/api/quote-requests`, form);
      setStatus('success');
    } catch { setStatus('error'); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/40 backdrop-blur-sm overflow-y-auto py-8">
      <div className="bg-white rounded-2xl max-w-lg w-full mx-4 shadow-2xl">
        <div className="flex items-center justify-between p-6 border-b border-slate-100">
          <h2 className="text-lg font-bold text-[#0A1628]">{t('quote.title')}</h2>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600 rounded-lg"><X className="w-5 h-5" /></button>
        </div>

        {status === 'success' ? (
          <div className="p-10 text-center">
            <CheckCircle className="w-14 h-14 text-emerald-500 mx-auto mb-4" />
            <p className="font-semibold text-[#0A1628] text-lg mb-2">{t('quote.success')}</p>
            <button onClick={onClose} className="mt-6 text-sm text-[#00B4D8] font-medium hover:underline">{isRTL ? 'إغلاق' : 'Close'}</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            <p className="text-sm text-slate-500 mb-2">{t('quote.subtitle')}</p>
            <input required placeholder={t('quote.name')} value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
              className="w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#00B4D8] outline-none" />
            <input placeholder={t('quote.company')} value={form.company} onChange={e => setForm(p => ({ ...p, company: e.target.value }))}
              className="w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#00B4D8] outline-none" />
            <div className="grid grid-cols-2 gap-3">
              <input required placeholder={t('quote.phone')} value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))}
                className="w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#00B4D8] outline-none" />
              <input type="email" placeholder={t('quote.email')} value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
                className="w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#00B4D8] outline-none" />
            </div>
            <input placeholder={t('quote.city')} value={form.city} onChange={e => setForm(p => ({ ...p, city: e.target.value }))}
              className="w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#00B4D8] outline-none" />
            <select value={form.product} onChange={e => setForm(p => ({ ...p, product: e.target.value }))}
              className="w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#00B4D8] outline-none bg-white">
              <option value="">{t('quote.selectProduct')}</option>
              {products.map(p => (
                <option key={p.id} value={p[`name_${lang}`] || p.name_ar}>{p[`name_${lang}`] || p.name_ar}</option>
              ))}
            </select>
            <textarea rows={3} placeholder={t('quote.desc')} value={form.description} onChange={e => setForm(p => ({ ...p, description: e.target.value }))}
              className="w-full border border-slate-200 rounded-lg px-4 py-2.5 text-sm focus:border-[#00B4D8] outline-none resize-none" />
            <button type="submit" disabled={status === 'sending'}
              className="w-full flex items-center justify-center gap-2 bg-[#00B4D8] hover:bg-[#0094B3] text-white font-semibold py-3 rounded-lg transition-colors text-sm disabled:opacity-50">
              {status === 'sending' ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
              {t('quote.submit')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default QuoteFormModal;
